module.exports = __webpack_public_path__ + "img/1inch.607f24ed.png";